const SHOPIFY_CDN = /\/cdn\/shop\/|cdn\.shopify\.com/
const SVG = /\.svg(\?|$)/i

// 900 sits between 600 and 1200 because a ~325px card at 2x needs 650px and
// would otherwise jump a whole 1200w image.
const WIDTHS = [200, 400, 600, 900, 1200, 1600, 2560]

/**
 * Point a Shopify CDN url at one width. A `_{w}x{h}` suffix already in the
 * filename pins the served size, so it has to be replaced rather than have a
 * width parameter added beside it; every other url takes `width=`.
 */
const atWidth = (url, width) => {
  if (/_\d+x\d*\./.test(url)) return url.replace(/_\d+x\d*\./, `_${width}x.`)
  const base = url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '')
  return `${base}${base.includes('?') ? '&' : '?'}width=${width}`
}

/**
 * src and srcset for a Shopify CDN image url.
 * @param {string} url
 * @returns {{src: string, srcSet: string}|null} null for anything else, including
 * the Nosto CDN some swatch images come from, which has no width parameter, and
 * SVGs: the CDN serves the same vector at every width, so `w` descriptors would
 * only shrink it below its own size.
 */
export const cdnImage = (url) => {
  if (typeof url !== 'string' || !SHOPIFY_CDN.test(url) || SVG.test(url)) return null
  return {
    // src is only a fallback for browsers without srcset, so keep it mid-sized.
    src: atWidth(url, 600),
    srcSet: WIDTHS.map((w) => `${atWidth(url, w)} ${w}w`).join(', ')
  }
}
